import type { IntlShape } from 'react-intl';

import type { ColorConfig } from './contracts';
import messages from './support-chat.i18n';
import { colorMap, hardcodedTextHeaders } from './support-chat.settings';

const getColorMap = (element: HTMLElement): ColorConfig => {
  return Object.keys(colorMap).reduce((acc, configName) => {
    const themeVar = colorMap[configName] as string;
    const color = window.getComputedStyle(element).getPropertyValue(themeVar);

    acc[configName] = color;

    return acc;
  }, {} as ColorConfig);
};

const translations = messages.pages.landing.onlineSupport.supportChat;

const getHeaderMessage = (formatMessage: IntlShape['formatMessage'], currentLanguage: string): React.ReactNode => {
  return hardcodedTextHeaders[currentLanguage] || formatMessage(translations.component.headerWithTranslations);
};

export { getColorMap, getHeaderMessage };
